import Loadable from 'react-loadable';
import Spin from 'components/common/Spin';

export default (loader) => Loadable({
  loader,
  loading: Spin,
  delay: 200,
  timeout: 10000,
});
